import { SectionHeader } from "@/components/ui/SectionHeader";
import { Shield, Clock, BadgeDollarSign, TrendingUp, HeartHandshake } from "lucide-react";
import { useScrollReveal } from "@/hooks/use-scroll-reveal";
import whyChooseImg from "@/assets/why-choose-us.jpg";

const benefits = [
  {
    icon: Shield,
    title: "Compliance Peace of Mind",
    description: "Stay on the right side of SARS with our thorough compliance management and deadline tracking.",
  },
  {
    icon: Clock,
    title: "Consistent Monthly Delivery",
    description: "Reliable, on-time bookkeeping every month. No more last-minute rushes or missed deadlines.",
  },
  {
    icon: BadgeDollarSign,
    title: "Clear, Transparent Pricing",
    description: "Know exactly what you're paying. Our packages include everything with no hidden fees.",
  },
  {
    icon: TrendingUp,
    title: "Scalable Support",
    description: "Start with what you need, upgrade as you grow. We scale with your business seamlessly.",
  },
  {
    icon: HeartHandshake,
    title: "Friendly, Responsive Support",
    description: "We're here when you need us. Quick responses, clear communication, and genuine care.",
  },
];

export function WhyChooseUs() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section className="py-20 lg:py-28 section-white">
      <div className="container mx-auto px-4">
        <SectionHeader
          label="Why Us"
          title="Why Choose Bookkeeping Services SA"
          description="We combine expertise, reliability, and genuine care to deliver bookkeeping services you can trust."
        />

        <div className="max-w-6xl mx-auto grid lg:grid-cols-3 gap-10 items-start">
          {/* Image column */}
          <div className="hidden lg:block lg:col-span-1">
            <img
              src={whyChooseImg}
              alt="Professional accountant reviewing financial documents"
              className="rounded-2xl shadow-lg object-cover w-full h-[480px]"
              loading="lazy"
            />
          </div>

          {/* Benefits grid */}
          <div
            ref={ref}
            className="lg:col-span-2 grid sm:grid-cols-2 gap-6 reveal-stagger"
          >
            {benefits.map((benefit) => (
              <div
                key={benefit.title}
                className={`card-elevated p-6 scroll-reveal-scale ${isVisible ? "revealed" : ""}`}
              >
                <div className="icon-container mb-4">
                  <benefit.icon className="w-6 h-6" />
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground mb-2">
                  {benefit.title}
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
